import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import axios from "axios";
import { Token } from "./Assets/Scripts/Models/Token";
import { CustomError } from "./Assets/Scripts/Models/CustomError";

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        //todo if token empty exit - allow for login 
        // if(token===null || token===""){
        //     Promise.reject("Invalid token / user");
        // }
        config.headers = {
            "Content-Type": "application/json",
            authorization: "Bearer " + token,
        };

        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        if (error.response && error.response.data) {
            let result={};
            if(typeof error.response.data === "string"){
                result = {errors:[error.response.data]}
            } else if(typeof error.response.data === "object" && "errors" in error.response.data){
                result= error.response.data as CustomError;
            }else {
                result= {error:["Unknown error"]}
            }
            return Promise.reject(result);
        } else if("isAxiosError" in error ){
            const originalRequest = error.config;

            if (
                error.response.status === 401 &&
                originalRequest.url ===
                    process.env.REACT_APP_API_URL + "/api/v1/identity/refresh"
            ) {
                return Promise.reject({errors:[error.response.statusText]});
            }

            //have to handle custom errors
            if (error.response.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true;

                const token = localStorage.getItem("token");
                const refreshToken = localStorage.getItem("refreshToken");

                const response = await axios.post(
                    process.env.REACT_APP_API_URL + "/api/v1/identity/refresh",
                    {
                        token: token,
                        refreshToken: refreshToken,
                    }
                );

                if (response.status === 201 || response.status === 200) {
                    const responseData = response.data as Token;
                    localStorage.setItem("token", responseData.token);
                    localStorage.setItem(
                        "refreshToken",
                        responseData.refreshToken
                    );

                    //change auth header
                    axios.defaults.headers.common["Authorization"] =
                        "Bearer " + responseData.token;

                    return axios(originalRequest);
                }
            }
        }
    }
);

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
